// extracted by mini-css-extract-plugin
export var news = "styles-module--news--hUK1U";
export var newstext_title = "styles-module--newstext_title--kbcZp";
export var news_image_inner = "styles-module--news_image_inner--2-hdx";
export var news_image = "styles-module--news_image--Zydig";
export var news_text = "styles-module--news_text--3otfS";
export var newstext = "styles-module--newstext--23J4q";
export var newstext_top = "styles-module--newstext_top--1Qumr";
export var newstext_date = "styles-module--newstext_date--2XvXk";
export var newstext_suptitle = "styles-module--newstext_suptitle--wT6nS";